export default __webpack_public_path__ + "static/media/butcheredmeat.e0f804ae.jpg";